export const formatScope = (scope: string) => scope.replace(':', '.')
